import { apiClient } from './client.js';

export const subscriptionApi = {
  /**
   * Lấy thông tin gói cước của học viên đang đăng nhập
   */
  getMySubscription: () => {
    return apiClient.get('/subscriptions/my');
  },

  /**
   * Admin: Lấy danh sách tất cả các gói thuê bao & học viên
   */
  getAllSubscriptions: (params = {}) => {
    return apiClient.get('/subscriptions', { params });
  },

  /**
   * Admin: Cấp mới hoặc Nâng cấp gói cước cho học viên
   */
  grantSubscription: (data) => {
    return apiClient.post('/subscriptions/grant', data);
  },

  /**
   * Admin: Cập nhật trạng thái / Gia hạn subscription
   */
  updateSubscription: (id, data) => {
    return apiClient.patch(`/subscriptions/${id}`, data);
  },
};
